<tt-form-field-base
    [ttRememberId]="ttRememberId"
    [ttRememberDebounceTime]="ttRememberDebounceTime"
    [ttFieldId]="id.input"
    [ttLabel]="ttLabel"
    [ttLabelView]="ttLabelView"
    [ttTranslateLabel]="ttTranslateLabel"
    [ttSublabel]="ttSublabel"
    [ttTranslateSublabel]="ttTranslateSublabel"
    [ttToggleTipText]="ttToggleTipText"
    [ttTranslateToggleTipText]="ttTranslateToggleTipText"
    [ttInvalid]="ttInvalid"
    [ttInvalidText]="ttInvalidText"
    [ttTranslateInvalidText]="ttTranslateInvalidText"
    [ttRequired]="ttRequired"
    [ttReadonly]="ttReadonly"
    [ttDisabled]="ttDisabled"
    [ttStyle]="ttStyle"
    ttInputType="datetime"
>
    <div [attr.id]="id.inputGroup" class="tt-input__group--time">
        <span class="tt-input__icon--time fa-fw fal fa-clock"></span>
        <tt-time-input
            [ttId]="id.input"
            [ttTabable]="ttTabable"
            [(ttModel)]="ttModel"
            (ttModelChange)="onModelChange($event)"
            (focusout)="onBlur()"
            [ttTabable]="ttTabable"
            [ttRelativeElement]="id.inputGroup"
            [ttDisabled]="ttDisabled"
            [ttReadonly]="ttReadonly"
            [ttMinutePrecision]="ttMinutePrecision"
            [ttShowSeconds]="ttShowSeconds"
            [ttRoundTime]="ttRoundTime"
            [ttAllowEmpty]="ttAllowEmpty"
        ></tt-time-input>
    </div>

    <tt-form-field-buttons *ngIf="ttButtons" [ttButtons]="ttButtons" [ttButtonParms]="ttButtonParms"></tt-form-field-buttons>
</tt-form-field-base>
